export default __webpack_public_path__ + "static/media/b_speaking_small.196ecaca.png";